import API from '../../../../../services/api';

export const API_TRANSPORTISTAS = {
    getTransportistas: async () => {
        return await API.get('/transportistas').then(res => res.data);
    },
    newTransportista: async (tarifa) => {
        return API.post('/transportistas', tarifa).then(res => res.data);
    },
    updateTransportista: async (tarifa) => {
        return API.put('/transportistas/' + tarifa.id, tarifa).then(res => res.data);
    },
    deleteTransportista: async (idTarifa) => {
        return API.delete('/transportistas/' + idTarifa).then(res => res.data);
    }
}